const locale = ( typeof ( window.AppLocale ) !== 'undefined' ? window.AppLocale : false );
if ( !locale ) {
    throw new Error( 'AppLocale not loaded' );
}

jQuery(document).ready(function ($) {
    "use strict";

    const AgeGate = {
        lsDataName: 'bth_ls_data',
        ckName: 'bth_verified',
        _lsData: {
            age_verified: false,
            remember_me: false,
        },
        lsData: {},

        init: function () {
            var _lsData = localStorage.getItem( this.lsDataName );
            this.lsData = ( _lsData ? JSON.parse( _lsData ) : this._lsData );

            if ( !this.lsData.age_verified ) {
                if ( !locale.is_page_gate && 0) {
                    window.location.href = locale.age_gate_url + '?redirect_to=' + document.location.href;
                }
                this.__setupHooks();
            }
            else if ( !this.lsData.remember_me ) {
                //#! check cookie
                var ck = this.__getCookie( this.ckName );
                if ( parseInt( ck ) !== 1 ) {
                    this.__setupHooks();
                }
            }
        },

        __saveAndRedirectHome: function (verified, rememberMe) {
            this.lsData.age_verified = verified;
            this.lsData.remember_me = rememberMe;
            localStorage.setItem( this.lsDataName, JSON.stringify( this.lsData ) );

            //#! set a cookie to signal > verified with ! rememberMe
            if ( verified && !rememberMe ) {
                document.cookie = this.ckName + "=1";
            }

            if ( this.lsData.age_verified ) {
                var redirectTo;

                if (typeof URLSearchParams === 'function') {
                    var urlParams = new URLSearchParams(window.location.search);
                    redirectTo = urlParams.get('redirect_to');
                } else {
                    redirectTo = window.location.search.split('?redirect_to=')[1];
                }

                if (redirectTo) {
                    window.location.href = redirectTo;
                } else {
                    window.location.href = locale.home_page_url;
                }
            }
            else {
                window.location.href = locale.age_gate_url;
            }
        },

        __getCookie: function (ckName) {
            var name = ckName + "=",
                decodedCookie = decodeURIComponent( document.cookie ),
                ca = decodedCookie.split( ';' );
            for ( var i = 0; i < ca.length; i++ ) {
                var c = ca[i];
                while ( c.charAt( 0 ) === ' ' ) {
                    c = c.substring( 1 );
                }
                if ( c.indexOf( name ) === 0 ) {
                    return c.substring( name.length, c.length );
                }
            }
            return '';
        },

        __setupHooks: function () {
            var self = this;
            $( '#js-btn-yes' ).on( 'click', function (ev) {
                ev.preventDefault();
                self.__saveAndRedirectHome( true, $( '#remember-check:checked' ).length > 0 );
            } );
            $( '#js-btn-no' ).on( 'click', function (ev) {
                ev.preventDefault();
                self.__saveAndRedirectHome( false, false );
            } );
        },
    };

    
});
